import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useQuery} from '@tanstack/react-query';
import {useParams} from 'react-router-dom';

import {useResponseIndexQueryConfig} from '../../../query/Response/Query';
import {useUniversityDetailQueryConfig} from '../../../query/University/Query';
import ResponsesContent from './ResponsesContent';

const Responses: FunctionComponent = () => {
    const { id } = useParams();

    const [universityConfig] = useUniversityDetailQueryConfig(Number(id));
    const [responsesConfig, setPage] = useResponseIndexQueryConfig(Number(id));

    const universityQuery = useQuery(universityConfig);
    const responsesQuery = useQuery(responsesConfig);

    return (
        <Page className={'admin-responses-page'}>
            { (universityQuery.data && responsesQuery.data) &&
                <ResponsesContent
                    university={universityQuery.data}
                    responses={responsesQuery.data}
                    onPageChange={setPage} />
            }
        </Page>
    );
};

export default Responses;
